import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../../Button'
import { QA_NAME_APPLICANT_CHECKLIST_VERIFY } from '../../ApplicantDocumentChecklist.constants'
import { ApplicantDocumentChecklistActionCell } from '../ApplicantDocumentChecklistActionCell'

import * as styles from './ApplicantDocumentChecklistVerifyCell.module.css'

function ApplicantDocumentChecklistVerifyCell({
  canVerify,
  disabled,
  isLoading,
  tooltip,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <ApplicantDocumentChecklistActionCell
      className={styles.ApplicantDocumentChecklistVerifyCell}
    >
      {canVerify ? (
        <Button.Contained
          disabled={disabled}
          height={BUTTON_HEIGHT_32}
          isLoading={isLoading}
          qaName={QA_NAME_APPLICANT_CHECKLIST_VERIFY}
          text={t('RentalPortal.ApplicantDocumentVerifyBtnKey')}
          tooltip={tooltip}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={onClick}
        />
      ) : null}
    </ApplicantDocumentChecklistActionCell>
  )
}

export default ApplicantDocumentChecklistVerifyCell
